export const WISHLIST_KEY = "jooti_wishlist";

export const readLocalWishlist = () => {
  try {
    const value = JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]");
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

export const writeLocalWishlist = (items) => {
  const safeItems = Array.isArray(items) ? items : [];
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(safeItems));
  localStorage.setItem("wishlist", JSON.stringify(safeItems));
  window.dispatchEvent(new CustomEvent("jooti:wishlist-updated"));
};

export const clearLocalWishlist = () => {
  localStorage.removeItem(WISHLIST_KEY);
  localStorage.removeItem("wishlist");
  window.dispatchEvent(new CustomEvent("jooti:wishlist-updated"));
};

export const isLocalWishlistItem = (items, id) =>
  items.some((item) => String(item.id) === String(id));

export const localWishlistProductIds = () =>
  readLocalWishlist()
    .map((item) => Number(item.id || item.product_id))
    .filter(Boolean);
